var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNtpIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2a7 7 0 100 14A7 7 0 008 2zm0 12.625a5.624 5.624 0 110-11.25 5.624 5.624 0 110 11.25zm6.606-10.138a3 3 0 00-4.98-3.321 8.008 8.008 0 014.98 3.322zM6.374 1.166a3 3 0 00-4.98 3.321 8.006 8.006 0 014.98-3.322z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.457 11.043l-1.414 1.414L8 10.414l-2.043 2.043-1.414-1.414L6.586 9 4.543 6.957l1.414-1.414L8 7.586l2.043-2.043 1.414 1.414L9.414 9l2.043 2.043z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtpIcon);
export default __webpack_public_path__ + "static/media/ntp-icon.c9dc225fd1811f25638ee1b04795a1a7.svg";
export { ForwardRef as ReactComponent };